import AutoReplyDialog from './component'
export { AutoReplyDialog }
export default AutoReplyDialog